<form [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <div class="measurements"
         formArrayName="measurements">
        <ng-container *ngFor="let item of array('measurements').controls; let i = index;">
            <div class="measurement_row" [formGroupName]="i">
                <ng-container [ngTemplateOutlet]="measurementRow"
                              [ngTemplateOutletContext]="{index:i}">
                </ng-container>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="array('measurements').controls.length === 0 then noItems"></ng-container>
    <app-button type="primary" library="fontawesome" icon="fa-plus" (clicked)="addItem()">
        {{ 'generic.buttons.add' | translate }}
    </app-button>
</form>


<ng-template #measurementRow let-index='index'>
    <div class="left-side">
        <div class="heading">
            <app-input
                class="measurement-title"
                [formControl]="arrayControl(index, 'title')"
                [showErrors]="showValidations || arrayControl(index, 'title').invalid && arrayControl(index, 'title').touched"
                placeholder="{{'admin.strain.tickets.reports.modal.step5.measurementTitle' | translate}}">
            </app-input>
            <div class="buttons">
                <app-circular-button size="regular"
                                     pack="fa"
                                     icon="fa-clone"
                                     (clicked)="onDuplicate(index)">
                </app-circular-button>
                <app-circular-button *ngIf="array('measurements').controls.length > 1"
                                     size="regular"
                                     icon="delete"
                                     type="danger"
                                     (clicked)="removeItem(index)">
                </app-circular-button>
            </div>
        </div>
        <app-dropdown-autocomplete *ngIf="index === 0"
                                   class="reason"
                                   valueField="id"
                                   displayField="name"
                                   emptyText="{{'admin.strain.tickets.reports.modal.step5.reason' | translate}}"
                                   [formControl]="control('reason')"
                                   [items]="reasons"
                                   [canAddOther]="true"
                                   [hasInputForOther]="true"
                                   [otherPlaceholder]="'admin.strain.tickets.reports.modal.step5.reason' | translate"
                                   [showErrors]="showValidations || control('reason').touched && control('reason').invalid">
        </app-dropdown-autocomplete>
        <app-textarea
            class="observations"
            [formControl]="arrayControl(index, 'observations')"
            [showErrors]="arrayControl(index, 'observations').invalid && arrayControl(index, 'observations').touched"
            [maxLength]="120"
            placeholder="{{'admin.strain.tickets.reports.modal.step5.observations' | translate}}">
        </app-textarea>

    </div>
    <div class="right-side">
        <div class="excel-upload">
            <app-button type="primary"
                        icon="fa-file-excel-o"
                        [disabled]="isImporting[index]"
                        (clicked)="excelInput.click()">
                {{ 'admin.strain.tickets.reports.modal.step5.importExcel' | translate }}
            </app-button>
            <input #excelInput
                   type="file"
                   accept=".xlsx"
                   hidden
                   (change)="onExcelFileSelected(index, $event)">
        </div>
        <app-loading-spinner *ngIf="isImporting[index]" class="excel-import-spinner"></app-loading-spinner>
        <span>{{ 'admin.strain.tickets.reports.modal.step5.measurementGraph' | translate }}</span>
        <ng-container [ngTemplateOutlet]="hasChartImage(index) ? displayMeasurementGraph : uploadMeasurementGraph"
                      [ngTemplateOutletContext]="{index:index}"></ng-container>

        <span>{{ 'admin.strain.tickets.reports.modal.step5.measurementValuesImage' | translate }}</span>
        <ng-container [ngTemplateOutlet]="hasGageValues(index) ? displayGageValues : uploadGageValues"
                      [ngTemplateOutletContext]="{index:index}"></ng-container>

    </div>
</ng-template>
<ng-template #noItems let-index='index'>
    <app-alert [responsive]="true"
               type="info"
               message="{{'admin.strain.registry.create.step5.info'| translate}}">
    </app-alert>
</ng-template>


<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>

<ng-template #uploadMeasurementGraph let-index='index'>
    <app-excel-chart-paste (onFileSelected)="selectMeasurementGraphs(index, $event)"></app-excel-chart-paste>
</ng-template>

<ng-template #displayMeasurementGraph let-index='index'>
    <app-strain-measurement-image
        [image]="getChartImage(index)"
        (resetImage)="changeChartImage(index, $event)">
    </app-strain-measurement-image>
</ng-template>


<ng-template #uploadGageValues let-index='index'>
    <app-excel-paste-table
        (onPaste)="selectMeasurementValues(index, $event)">
    </app-excel-paste-table>
</ng-template>

<ng-template #displayGageValues let-index="index">
    <app-excel-paste-table
        [data]="getGageChart(index)"
        (onPaste)="selectMeasurementValues(index, $event)">
    </app-excel-paste-table>
</ng-template>
